module.exports = __webpack_public_path__ + "img/AD1.f7023b58.png";